import React from 'react';
import { useEffect, useState, useMemo, useRef } from 'react'
import NoDataFound from '../../shared/NoDataFound';
import { useTableState } from './utils/useTableState';
import { alphaformatDateTime } from "../../utils/dateFormat"
import TableLoader from '../../shared/TableLoader';
import config from "../../config";
import { version } from "../../assets/svg";
import VersionsRow from './components/VersionsRow';
import Select from 'react-select';
import Datepicker from 'react-tailwindcss-datepicker';
import { renderLocationDetails, renderSalesPersonCell } from './utils/cellRenderers';
import { useUnreadCountPolling } from './utils/useUnreadCountPolling';
import { useVisibleRowIds } from './utils/useVisibleRowIds';


const AbortAds = ({ abortDesigns, setabortDesigns, totalabort, settotalabort, activechild, currentPage, setCurrentPage, handlePageChange, loader, getAbortedDesigns, hasMore, onLoadMore, dateRange, setDateRange, adType, setAdType, search, setSearch}) => {
  const { visibleIds, rowRef } = useVisibleRowIds();
  const liveUnread = useUnreadCountPolling(abortDesigns, "/user/designer/getUnreadCounts", {
    enabled: activechild === "abort-Ads",
    visibleIds,
  });
  const sentinelRef = useRef(null);

  useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!sentinel || !onLoadMore || !hasMore) return;
    const observer = new IntersectionObserver(
      (entries) => { if (entries[0].isIntersecting) onLoadMore(); },
      { threshold: 0.1 }
    );
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [hasMore, onLoadMore, abortDesigns.length]);

  const { 
    expandedVersionsRow,
    actionHandlers,
    closeExpandedRows
  } = useTableState();


  useEffect(() => {
    setCurrentPage(0);
  }, [activechild])


    return (
        <div>
            <div className="overflow-auto">
                <table className="table table-bordered">
                    <thead>
                        <tr className="bg-gray-100">
                            <th className="p-2 text-left">Sales Person Details</th>
                            {/* <th>Ad Creation Date</th> */}
                            {/* <th>Brand</th> */}
                            <th>Campaign Name</th>
                            {/* <th>Start Date</th> */}
                            <th>Location Details</th> 
                            <th>Ad Type</th>
                            <th>Adops</th>
                            <th>Assign Time</th>
                            <th>Reason</th>
                        </tr>
                    </thead>
             {(abortDesigns.length > 0  && !loader ) ? (abortDesigns.map((rawRow, idx) => {
              const liveCount = liveUnread[rawRow.creative_id];
              const row = liveCount != null ? { ...rawRow, unread_count: liveCount, unreadCount: liveCount } : rawRow;
              const assign_date = alphaformatDateTime(row.assigndate);
              return (
              <tbody ref={rowRef(rawRow.creative_id)}>
                <tr key={idx} className="border-t">
                  <td>
                    {renderSalesPersonCell(row.sales_person,row)}
                  </td>
                  {/* <td>
                    <div className='font-bold'>{created_at.dateStr}</div>
                    <div className="text-xs text-gray-500 font-bold">{created_at.timeStr}</div>
                  </td> */}
                  {/* <td>{row.brand_name}</td> */}
                  <td>{row.creative_name}</td>
                  {/* <td className="p-2">
                    <div className='font-bold'>{start_date.dateStr}</div>
                    <div className="text-xs text-gray-500 font-bold">{start_date.timeStr}</div>
                  </td> */}
                  <td>
                  {renderLocationDetails(row)}
                </td>
                  <td>{row.ad_type}</td>
                  <td>{row.cst_name}</td>
                  <td className="p-2 font-bold">
                    <div>{assign_date.dateStr}</div>
                    <div className="text-xs text-gray-500">{assign_date.timeStr}</div>
                  </td>
                  <td>
                    {row.status === 0 ? <div>Moved to another Designer</div> : <div>Final creative Recieved</div>}
                  </td>
                </tr>
              </tbody>
              )
            })) : (!abortDesigns.length > 0 && !loader) ? (<NoDataFound colspan="11" />)
          : (<TableLoader colspan="11"/>)}
                </table>
            </div>
      {hasMore && !loader && <div ref={sentinelRef} className="h-6 w-full" />}
      {loader && abortDesigns.length > 0 && <div className="flex justify-center py-3"><div className="spinner-border text-primary" role="status" /></div>}
        </div>
    )
}
export default AbortAds;